import i18n from '@/utils/i18n'

export const SIGNUP_PHONE_CODES = [
  { value: '+82', label: 'KR +82' },
  { value: '+81', label: 'JP +81' },
  { value: '+1', label: 'US +1' },
  { value: '+84', label: 'VN +84' },
  { value: '+63', label: 'PH +63' },
  { value: '+66', label: 'TH +66' }
]

const SIGNUP_PHONE_CODE_BY_LOCALE = {
  en: '+1',
  ko: '+82',
  ja: '+81',
  zh: '+82'
}

export function getDefaultSignupPhoneCode (locale) {
  const code = SIGNUP_PHONE_CODE_BY_LOCALE[String(locale || '').toLowerCase()]
  if (code && SIGNUP_PHONE_CODES.some(item => item.value === code)) {
    return code
  }
  return '+82'
}

export function getSignupPhoneCodes (locale) {
  const preferred = getDefaultSignupPhoneCode(locale)
  const list = SIGNUP_PHONE_CODES.slice()
  const index = list.findIndex(item => item.value === preferred)
  if (index <= 0) return list
  const [preferredItem] = list.splice(index, 1)
  return [preferredItem, ...list]
}

export function getSignupPhoneLabels () {
  return {
    phone: i18n.t('auth.phone'),
    sendCode: i18n.t('auth.sendCode'),
    resendCode: i18n.t('auth.resendCode'),
    confirmCode: i18n.t('auth.confirmCode'),
    codePlaceholder: i18n.t('auth.codePlaceholder'),
    verified: i18n.t('auth.phoneVerified'),
    needVerify: i18n.t('auth.phoneNeedVerify'),
    invalidPhone: i18n.t('auth.phoneInvalid'),
    sendFail: i18n.t('auth.phoneSendFail'),
    verifyFail: i18n.t('auth.phoneVerifyFail'),
    needCode: i18n.t('auth.phoneNeedCode')
  }
}

export const SIGNUP_PHONE_LABELS = getSignupPhoneLabels()

export function getSignupErrorMessage (code, fallback) {
  const map = {
    2009: i18n.t('auth.errorDuplicateLoginId'),
    2021: i18n.t('auth.errorDuplicateNickname'),
    2023: i18n.t('auth.errorReferralInvalid'),
    2035: i18n.t('auth.errorDuplicateIp')
  }
  return map[Number(code)] || fallback || i18n.t('auth.signupFail')
}

export function normalizePhoneDigits (value) {
  return String(value || '').replace(/\D/g, '')
}

export function buildSignupPhoneNumber (phoneCode, phone) {
  const digits = normalizePhoneDigits(phone)
  const code = String(phoneCode || '').trim()
  if (!code || !digits) return ''
  return `${code}${digits}`
}

export function validateSignupForm (form) {
  const loginid = String(form.loginid || '').trim()
  const name = String(form.name || '').trim()
  const loginpwd = String(form.loginpwd || '')
  const loginpwdConfirm = String(form.loginpwdConfirm || '')
  const pcode = String(form.pcode || '').trim()

  if (!loginid) {
    return i18n.t('auth.errorLoginIdRequired')
  }
  if (!/^[a-zA-Z0-9]{4,12}$/.test(loginid)) {
    return i18n.t('auth.errorLoginIdFormat')
  }
  if (!name) {
    return i18n.t('auth.errorNicknameRequired')
  }
  if (name.length < 2 || name.length > 12) {
    return i18n.t('auth.errorNicknameLength')
  }
  if (!loginpwd) {
    return i18n.t('auth.errorPasswordRequired')
  }
  if (loginpwd.length < 4 || loginpwd.length > 20) {
    return i18n.t('auth.errorPasswordLength')
  }
  if (!loginpwdConfirm) {
    return i18n.t('auth.errorPasswordConfirmRequired')
  }
  if (loginpwd !== loginpwdConfirm) {
    return i18n.t('auth.errorPasswordMismatch')
  }
  const phoneDigits = normalizePhoneDigits(form.phone)
  if (!phoneDigits || phoneDigits.length < 7) {
    return i18n.t('auth.phoneInvalid')
  }
  if (!form.phoneVerified) {
    return i18n.t('auth.phoneNeedVerify')
  }
  if (!pcode) {
    return i18n.t('auth.errorReferralRequired')
  }
  return ''
}
